import { render, staticRenderFns } from "./TodoItemEdit.vue?vue&type=template&id=f189ed70&"
import script from "./TodoItemEdit.vue?vue&type=script&lang=js&"
export * from "./TodoItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports